<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-ellipsis-h me-2"></i>{{ TR.menu }}
        </div>

        <div class="card-body">
            <DADataTable
                ref="menu_table_ref"
                v-if="tableData"
                :tableData="tableData"
                :tableOptions="tableOptions"
            />
        </div>
    </div>
</template>


<script scoped>
    import { onMounted, ref, watchEffect } from "vue";
    import { useStore } from "@/system_modules/store";
    import moment from "moment-timezone";

    import { FilterMatchMode } from '@primevue/core/api';

    import { G, ajax } from "@/_common";
    import DADataTable from "@/components/table/DADataTable";

    export default {
        title: "menu",
        name: 'MenuP',

        // metaInfo: {
        //     title: 'Default App Title',
        //     titleTemplate: '%s | vue-meta Example App',
        //     htmlAttrs: {
        //         lang: 'az-AZ'
        //     },
        //     meta: [
        //         { charset: 'utf-8' },
        //         { vmid: 'description', name: 'description', content: 'An example Vue application with vue-meta.' },
        //         { vmid: 'description', name: 'viewport', content: 'width=device-width, initial-scale=1' },

        //         { property: 'og:title', content: "Epiloge - Build your network in your field of interest" },
        //         { property: 'og:site_name', content: 'Epiloge' },
        //         { property: 'og:type', content: 'website' },
        //         { property: 'og:image', content: '/users/-main.jpg' },

        //         { name: 'robots', content: 'index,follow' },
        //     ]
        // },

        components: {
            DADataTable,
        },
        setup() {
            const store = useStore();

            const tableData = ref([]);
            const tableOptions = ref();
            const menu = ref([]);
            const menu_table_ref = ref();
            const menu_type = ref([
                { value: "_self", label: "Cari səhifədə" },
                { value: "_blank", label: "Yeni səhifə" }
            ]);
            const menu_link_type = ref([
                { value: "link", label: "Link" },
                { value: "content", label: "Mətn" }
            ]);
            const TR = ref({});

            onMounted(async () => {
                await ajax({
                    url: store.getMenu(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            menu.value = [];
                            menu.value.push({ value: 0, label: `<b>${TR.value.main}</b>` });
                            // menu.value = menu.value.concat(res.filter(e => e.parent == 0).map((e) => {
                            menu.value = menu.value.concat(res.filter(e => e.status == 1).map((e) => {
                                return { value: e.id, label: e.translate[0].name };
                            }));
                            tableData.value = res;
                            // tableData.value.forEach(x => x.create_date = new Date(x.create_date));
                            tableData.value.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss")));
                        }
                    }
                });
            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: true,
                    // row_total_field: ['parent'],
                    // row_per_page: 5,

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    // modal: false,
                                    page: "components/table/DynamicTable2",
                                    data: {
                                        permission_method: 'add',
                                        type: 'link',
                                    },
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            field_type: "text",
                                            required: true
                                        },
                                        {
                                            private: (e) => e.newdata.type == 'link',
                                            name: "content",
                                            title: TR.value.content,
                                            field_type: 'editor',
                                            required: true
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            // fileSelectMode: 'advanced',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        // {
                                        //     name: "name",
                                        //     title: TR.value.name,
                                        //     // value: (e) => e.translate[0].name,
                                        //     field_type: "text",
                                        //     required: true
                                        // },
                                        {
                                            name: "code",
                                            title: TR.value.code,
                                            field_type: 'text',
                                        },
                                        // {
                                        //     name: "image_color",
                                        //     // value: (a) => { return {'r':3,'g':68,'b':108} },
                                        //     value: (e) => {
                                        //         if( e.image_color && e.image_color != '' ){
                                        //             // let cl = e.image_color.split(',');
                                        //             return G.userHavePermission('update') ? {"r": 3, "g": 68, "b": 108 } : `<span style="padding: 4px 12px; background-color: rgb($3, 68, 108)"></span>`;
                                        //         }
                                        //         else return '';
                                        //     },
                                        //     title: TR.value.color,
                                        //     field_type: 'color',
                                        // },
                                        {
                                            name: "parent",
                                            title: TR.value.parent,
                                            field_type: 'dropdown',
                                            dropdown_items: menu.value,
                                            dropdown_item_selected: 0
                                        },
                                        {
                                            name: "type",
                                            title: TR.value.menu_type,
                                            field_type: 'dropdown',
                                            dropdown_items: menu_link_type.value,
                                            dropdown_item_selected: "link"
                                        },
                                        {
                                            private: (e) => e.newdata.type == 'content',
                                            name: "link",
                                            title: TR.value.link,
                                            field_type: 'textarea',
                                        },
                                        {
                                            name: "target",
                                            title: TR.value.target,
                                            field_type: 'dropdown',
                                            dropdown_items: menu_type.value,
                                            dropdown_item_selected: "_self"
                                        },
                                        {
                                            name: "rank",
                                            title: TR.value.rank,
                                            value: () => 1,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    onModalClose: (e) => {
                                        G.closeModal(e);
                                    },
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.name != '' ){
                                                            let formData = new FormData();

                                                            if( e.image != null && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }

                                                            let menu_data = {
                                                                "code": e.code,
                                                                "parent": e.parent,
                                                                "rank": e.rank,
                                                                // "image_color": `${e.image_color.r},${e.image_color.g},${e.image_color.b}`,
                                                                "link": e.link ? e.link.replace("\n|\r", "<br />") : '',
                                                                "target": e.target,
                                                                "type": e.type,
                                                                "translate": G.lang_list.map((a) => {
                                                                    return {
                                                                            "lang_id": a.value,
                                                                            "name": e.name[a.value] || e.name[1],
                                                                            "content": e.content[a.value] || e.content[1],
                                                                        };
                                                                }),
                                                                "status": e.status ? 1 : 0,
                                                            };
                                                            if( e.image != null && typeof e.image !== 'object' )
                                                                menu_data.image = e.image;

                                                            formData.append("data", JSON.stringify(menu_data));

                                                            await ajax({
                                                                url: store.getMenu(),
                                                                method: 'post',
                                                                data: formData,
                                                                success: (x) => {
                                                                    let res1 = x.data || null;
                                                                    if ( x.status == 200 && res1) {
                                                                        res1.create_date = new Date(res1.create_date);
                                                                        // tableData.value.unshift(res);
                                                                        tableData.value.push(res1);
                                                                        G.alert.success(TR.value.msg_add_success);

                                                                        menu.value.push({ value: res1.id, label: res1.translate[0].name });
                                                                        G.closeModal(res);
                                                                    }
                                                                    else
                                                                        G.alert.error(res1.detail);
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status && res.status == 422 ){
                                                                //         G.alert.error({title: TR.value.warning, msg: G.getErrorMessages(res.data.detail)});
                                                                //     }
                                                                //     else
                                                                //         G.alert.error({msg: TR.value.msg_add_failed});
                                                                // }
                                                            });
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_name});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getMenuUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: data.translate[0].name,
                                    dismiss: false,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            value: (l) => l.name,
                                            title: TR.value.name,
                                            field_type: 'text',
                                            required: true
                                        },
                                        {
                                            private: (e) => e.newdata.type == 'link',
                                            name: "content",
                                            value: (l) => l.content,
                                            title: TR.value.content,
                                            field_type: 'editor',
                                            required: true
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                            // buttons: [
                                            //     // {
                                            //     //     name: "remove",
                                            //     //     title: `${TR.value.image} ${TR.value.remove}`,
                                            //     //     // value: (e) => e.translate[0].name,
                                            //     //     field_type: "element",
                                            //     //     type: "switch",
                                            //     //     // class: "btn btn-danger",
                                            //     //     // icon: "fas fa-trash",
                                            //     //     event: "change",
                                            //     //     callback: (e, item, po) => {
                                            //     //         po.newdata.remove = !po.newdata.remove;
                                            //     //     },
                                            //     // },
                                            // ]
                                        },
                                        // {
                                        //     name: "remove",
                                        //     title: `<span class="text-danger">${TR.value.image} ${TR.value.remove}</span>`,
                                        //     field_type: "switch",
                                        //     icon: "fas fa-trash",
                                        //     event: "change",
                                        //     callback: (e, item, po) => {
                                        //         console.log(po.newdata.remove);
                                        //     },
                                        // },
                                        {
                                            name: "remove_image",
                                            field_type: "element",
                                            buttons: [
                                                {
                                                    name: "remove",
                                                    type: "button",
                                                    icon: "fas fa-trash me-2",
                                                    class: "btn btn-danger",
                                                    text: `${TR.value.image} ${TR.value.remove}`,
                                                    event: "click",
                                                    callback: (_, __, po) => {
                                                        po.newdata.preview_image = '';
                                                        po.newdata.image = '';
                                                        po.newdata.remove = true;
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        // {
                                        //     name: "name",
                                        //     value: (e) => e.translate[0].name,
                                        //     title: TR.value.name,
                                        //     field_type: 'text',
                                        //     required: true
                                        // },
                                        {
                                            name: "code",
                                            value: "code",
                                            title: TR.value.code,
                                            field_type: 'text',
                                        },
                                        // {
                                        //     name: "image_color",
                                        //     value: (e) => {
                                        //         if( e.image_color && e.image_color != '' ){
                                        //             let cl = e.image_color.split(',');
                                        //             return G.userHavePermission('update') ? {"r": parseInt(cl[0]), "g": parseInt(cl[1]), "b": parseInt(cl[2]) } : `<span style="padding: 4px 12px; background-color: rgb(${e.image_color})"></span>`;
                                        //         }
                                        //         else return '';
                                        //     },
                                        //     title: TR.value.color,
                                        //     field_type: 'color',
                                        // },
                                        {
                                            name: "parent",
                                            value: "parent",
                                            title: TR.value.parent,
                                            // field_type: 'text',
                                            field_type: 'dropdown',
                                            dropdown_items: menu.value.filter(e => e.value !== data.id),
                                            dropdown_item_selected: data.parent
                                        },
                                        {
                                            name: "type",
                                            title: TR.value.menu_type,
                                            field_type: 'dropdown',
                                            dropdown_items: menu_link_type.value,
                                            dropdown_item_selected: data.type
                                        },
                                        {
                                            private: (e) => e.newdata.type == 'content',
                                            name: "link",
                                            value: "link",
                                            title: TR.value.link,
                                            field_type: 'textarea',
                                        },
                                        {
                                            name: "target",
                                            title: TR.value.target,
                                            field_type: 'dropdown',
                                            dropdown_items: menu_type.value,
                                            dropdown_item_selected: data.target
                                        },
                                        {
                                            name: "rank",
                                            value: "rank",
                                            title: TR.value.rank,
                                            field_type: 'integer',
                                            max: 10000,
                                            default: 1
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.name != '' ){

                                                            let formData = new FormData();
                                                            if( e.image != data.image && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }
                                                            let menu_data = {
                                                                "code": e.code,
                                                                "parent": e.parent,
                                                                "rank": e.rank,
                                                                // "image_color": `${e.image_color.r},${e.image_color.g},${e.image_color.b}`,
                                                                "link": e.link ? e.link.replace("\n|\r", "<br />") : '',
                                                                "target": e.target,
                                                                "type": e.type,
                                                                "translate": G.lang_list.map((a) => {
                                                                    return {
                                                                            "lang_id": a.value,
                                                                            "name": e.name[a.value] || e.name[1],
                                                                            "content": e.content[a.value] || e.content[1],
                                                                        };
                                                                }),
                                                                "status": e.status ? 1 : 0,
                                                            };

                                                            if( e.image != data.image && typeof e.image !== 'object' )
                                                                menu_data.image = e.image;

                                                            formData.append("data", JSON.stringify(menu_data));

                                                            await ajax({
                                                                url: store.getMenuUpdate(data.id),
                                                                method: 'patch',
                                                                data: formData,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if (res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        tableData.value.forEach(
                                                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                                                        );
                                                                        for (let a in res) {
                                                                            data[a] = res[a];
                                                                        }
                                                                        G.alert.success(TR.value.msg_update_success);
                                                                    }
                                                                },
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_title});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getMenuActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data;
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                                        tableData.value.forEach(
                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                        );
                                        for (let a in res) {
                                            data[a] = res[a];
                                        }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: 'status',
                        //     title: TR.value.status,
                        //     value: (e) => e.status == 0 ? false : true,
                        //     class: 'text-center',
                        //     element: 'switch',
                        //     eventName: 'change',
                        //     eventCallback: async (data, event) => {
                        //         await ajax({
                        //             url: store.getMenuActivate(data.id, event.target.checked ? 1 : 0),
                        //             method: 'post',
                        //             success: (a) => {
                        //                 let res = a.data;
                        //                 G.alert.success({msg: TR.value.msg_update_success});
                        //                 res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                        //                 tableData.value.forEach(
                        //                     (s) => { if ( s.id === res.id ) { s = res; } }
                        //                 );
                        //                 for (let a in res) {
                        //                     data[a] = res[a];
                        //                 }
                        //             }
                        //         });
                        //     },
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "image",
                            value: (e) => `<img src="${
                                                        e.image
                                                            ? e.image
                                                            : "/assets/img/noimg.png"
                                                    }"
                                                    alt="${e.image}"
                                                    class="border img-circle-cover"
                                                />`,
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "translate.0.name",
                            value: (e) => e.translate[0].name,
                            title: TR.value.name,
                        },
                        // {
                        //     name: "image_color",
                        //     value: (e) => `<span style="padding: 3px 10px; background-color: rgb(${e.image_color})"></span>`,
                        //     title: TR.value.color,
                        //     class: "text-center",
                        //     sortable: false,
                        //     filter: false,
                        //     // value: (e) => {
                        //     //     if( e.image_color && e.image_color != '' ){
                        //     //         let cl = e.image_color.split(',');
                        //     //         // return {"r": parseInt(cl[0]), "g": parseInt(cl[1]), "b": parseInt(cl[2]) };
                        //     //         return rgbToHex(parseInt(cl[0]), parseInt(cl[1]), parseInt(cl[2]));
                        //     //     }
                        //     //     // else return '';
                        //     // },
                        //     // element: 'color',
                        //     // eventName: 'change',
                        //     // eventCallback: async (event, data) => {
                        //     //     console.log(event);
                        //     //     // setTimeout(async () => {
                        //     //         let formData = new FormData();
                        //     //         let menu_data = {
                        //     //             "image_color": data,
                        //     //         };
                        //     //         formData.append("data", JSON.stringify(menu_data));

                        //     //         console.log(data);

                        //     //         await ajax({
                        //     //             url: store.getMenuUpdate(data.id),
                        //     //             method: 'patch',
                        //     //             data: formData,
                        //     //             success: (x) => {
                        //     //                 let res = x.data || null;
                        //     //                 if (res) {
                        //     //                     res.create_date = new Date(res.create_date);
                        //     //                     tableData.value.forEach(
                        //     //                         (s) => { if ( s.id === res.id ) { s = res; } }
                        //     //                     );
                        //     //                     for (let a in res) {
                        //     //                         data[a] = res[a];
                        //     //                     }
                        //     //                     G.alert.success(TR.value.msg_update_success);
                        //     //                 }
                        //     //             },
                        //     //             error: (x) => {
                        //     //                 var res = x.response || {};
                        //     //                 if( res.status == 422 ){
                        //     //                     G.alert.warning(G.getErrorMessages(res.data.detail));
                        //     //                 }
                        //     //                 else
                        //     //                     G.alert.warning(res.data.detail);
                        //     //             }
                        //     //         });
                        //     //     // }, 2000);
                        //     // },
                        //     // // elementClass: 'bg-danger',
                        //     // // attr: 'disabled',
                        //     // // attrValue: true,
                        //     // filter: false,
                        //     // sortable: false,
                        //     // exportable: false,
                        // },
                        {
                            name: "code",
                            value: "code",
                            title: TR.value.code,
                            visible: false,
                        },
                        {
                            name: "parent",
                            value: "parent",
                            title: TR.value.parent,
                            class: 'text-center',
                            filter: false
                        },
                        {
                            name: "rank",
                            value: "rank",
                            title: TR.value.rank,
                            class: 'text-center',
                            filter: false
                        },
                        {
                            name: "target",
                            value: "target",
                            title: TR.value.target,
                            class: 'text-center',
                            filter: false,
                            visible: false,
                        },
                        {
                            name: "type",
                            value: "type",
                            title: TR.value.type,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [
                                    { value: null, matchMode: FilterMatchMode.EQUALS },
                                    // { value: null, matchMode: 'equals' },
                                ],
                            },
                            field_type: "customFilter",
                            filter_field: "type",
                            filter_mode: "dropdown",
                            dropdown_items: menu_link_type.value,
                        },
                        {
                            name: "link",
                            value: (e) => e.link !== '' ? '<i class="fas fa-check text-success" />' : '<i class="fas fa-square border text-white" />',
                            title: TR.value.link,
                            class: 'text-center',
                            sortable: false,
                            filter: false
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            date_format: 'dd.mm.yy',
                            field_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            // function componentToHex(c) {
            //     var hex = c.toString(16);
            //     return hex.length == 1 ? "0" + hex : hex;
            // }
            // function rgbToHex(r, g, b) {
            //     return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
            // }

            return {
                TR,
                menu_table_ref,
                tableData,
                tableOptions,
            };
        },
    };
</script>

